/* global require */
import Vue from "vue";

// Child components
// (not strictly required, due to how extend works in vue, but worth keeping
// for a proper dependency tree)
import "./filter-chip.js";
import "./facet-group.js";
import "./freetext-search.js";
import "./manuscript-metadata.js";

// Import the original sidebar for extension
import SearchSidebar from "./search-sidebar.js";

// Global events
import { EventBus } from "./event-bus.js";

// Scroll locking
import { disableBodyScroll, enableBodyScroll, } from "body-scroll-lock";

export default Vue.component("mobile-search-sidebar", {
  extends: SearchSidebar,

  props: [ "state", "currentResults", "totalResults", "standalone" ],

  data() {
    return {
      filterMenuOpen: false
    };
  },

  computed: {
    filteredSubqueries() {
      if (!this.isManuscript) {
        return this.subqueries;
      } else {
        return this.subqueries
          .filter(f => f.fieldname !== "manuscript_numbers");
      }
    }
  },

  created() {
    // Bind global bus events.
    EventBus.$on(
      [ "esc-pressed", "query-without-filter", "query-with-filter", "query-with-freetext" ],
      () => { this.collapseFilterMenu(); }
    );
  },

  methods: {
    collapseFilterMenu() {
      this.filterMenuOpen = false;
    }
  },

  watch: {
    filterMenuOpen(newVal) {
      if (newVal === true) {
        disableBodyScroll(this.$refs.filterMenu);
      } else {
        enableBodyScroll(this.$refs.filterMenu);
      }
    }
  },

  template: require("./templates/mobile-search-sidebar.html"),
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/mobile-search-sidebar.js